import React from 'react';

export const InvoiceIcon = () => {
  return (
    <svg viewBox="0 0 300 300" className="w-full h-auto">
      <ellipse cx="150" cy="260" rx="140" ry="20" fill="#d1f4f0" opacity="0.5"></ellipse>
      <ellipse cx="150" cy="255" rx="120" ry="15" fill="#b8ede7" opacity="0.6"></ellipse>
      <ellipse cx="150" cy="250" rx="100" ry="10" fill="#9fe6dd" opacity="0.7"></ellipse>
      <rect x="160" y="100" width="90" height="120" rx="4" fill="#e5e7eb" transform="rotate(-5 205 160)"></rect>
      <rect x="165" y="105" width="80" height="110" rx="3" fill="#f3f4f6" transform="rotate(-5 205 160)"></rect>
      <line x1="170" y1="115" x2="235" y2="110" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="170" y1="125" x2="235" y2="120" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="170" y1="135" x2="220" y2="131" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="170" y1="150" x2="235" y2="145" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="170" y1="160" x2="235" y2="155" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="170" y1="170" x2="220" y2="166" stroke="#d1d5db" strokeWidth="2"></line>
      <rect x="170" y="185" width="50" height="20" rx="2" fill="#0d9488" opacity="0.2" transform="rotate(-5 195 195)"></rect>
      <text x="178" y="200" fontFamily="Inter, sans-serif" fontSize="14" fontWeight="600" fill="#0d9488" transform="rotate(-5 195 195)">INVOICE</text>
      <circle cx="90" cy="200" r="35" fill="#fbbf24"></circle>
      <circle cx="95" cy="195" r="35" fill="#f59e0b"></circle>
      <circle cx="100" cy="190" r="35" fill="#f59e0b" opacity="0.9"></circle>
      <path d="M 85 190 L 100 190 L 100 175 M 100 190 L 115 190 M 100 190 L 100 205" stroke="#ffffff" strokeWidth="6" fill="none" strokeLinecap="round"></path>
      <circle cx="90" cy="210" r="28" fill="#fbbf24" opacity="0.7"></circle>
      <circle cx="95" cy="205" r="28" fill="#f59e0b" opacity="0.6"></circle>
      <circle cx="100" cy="200" r="28" fill="#f59e0b" opacity="0.5"></circle>
      <path d="M 85 200 L 100 200 L 100 185 M 100 200 L 115 200 M 100 200 L 100 215" stroke="#ffffff" strokeWidth="5" fill="none" strokeLinecap="round" opacity="0.5"></path>
      <rect x="190" y="180" width="60" height="50" rx="4" fill="#7a9ca5"></rect>
      <rect x="195" y="185" width="50" height="40" rx="3" fill="#8fb3bc"></rect>
      <rect x="200" y="195" width="40" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="200" y="202" width="40" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="200" y="209" width="30" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="200" y="216" width="25" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <circle cx="215" cy="195" r="3" fill="#0d9488"></circle>
      <circle cx="225" cy="195" r="3" fill="#0d9488"></circle>
      <circle cx="235" cy="195" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="202" r="3" fill="#0d9488"></circle>
      <circle cx="225" cy="202" r="3" fill="#0d9488"></circle>
      <circle cx="235" cy="202" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="209" r="3" fill="#0d9488"></circle>
      <circle cx="225" cy="209" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="216" r="3" fill="#0d9488"></circle>
      <circle cx="225" cy="216" r="3" fill="#0d9488"></circle>
    </svg>
  );
};
